<template>
  <div class="news-detail">
    <Header :title="title">
      <div slot="right-sum">
        <i class="share-img" @click.stop="share()"></i>
      </div>
    </Header>
    <img class="banner" :src="newsDetail.thumb_img" />
    <p class="title">{{newsDetail.title}}</p>
    <div class="number">
      <p>{{newsDetail.click_rate}}次预览</p>
      <p>{{newsDetail.created_at | fomartTime('MM-dd')}}</p>
    </div>
    <p class="abstract">{{newsDetail.description}}</p>
    <div class="detail" v-html="newsDetail.content"></div>
    <book-share ref="share"></book-share>
    <service class="service_box" />
  </div>
</template>

<script>
import Header from "@/components/Header";
import bookShare from "@/components/book/BookShare.vue";
import Service from "@/components/Service";

export default {
  name: "news-detail",
  components: {
    Header,bookShare,Service
  },
  data() {
    return {
      title: {
        name: "资讯详情"
      },
      id: this.$route.query.id,
      newsDetail: {}, // 新闻详情
      showShare: false
    };
  },
  created() {
    this.requestDetail();
  },
  methods: {
    // request
    requestDetail() {
      this.$http
        .post("/api/app/information/detail", {
          information_id: this.id
        })
        .then(data => {
          this.newsDetail = data;
          this.$store.dispatch("setShare", {
            share_type: 2,
            route: this.$route,
            web_title: this.newsDetail.title,
            web_description: this.newsDetail.description,
            mobile_logo: this.newsDetail.thumb_img
          });
          document.title = this.newsDetail.title;
        });
    },
    //   分享
    async share(type) {
        if (this.$store.state.app) {//app内分享
          this.$pub.appAction("shareImg", {
            id: `${this.id}`,
            type: 5
          });
        } else {
          this.showShare = true;
          this.$nextTick(()=>{
            this.$refs.share.showModel();
          })
        }
    }
  }
};
</script>

<style lang="scss" scoped>
.news-detail {
  background-color: #fff;
  .banner {
    display: block;
    width: 100%;
  }
  .title {
    padding: 20px 40px;
    font-size: 45px;
    color: #222;
    line-height: 66px;
  }
  .share-img {
    display: inline-block;
    width: 60px;
    height: 86px;
    background: url("~@/assets/images/book/share.png") no-repeat center center;
    background-size: 35px 35px;
  }
  .number {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 40px;
    p {
      font-size: 24px;
      color: #b7b7b7;
      line-height: 24px;
    }
  }
  .abstract {
    position: relative;
    padding: 60px 85px;
    text-align: center;
    font-size: 32px;
    color: #999;
    line-height: 49px;
    &:after {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 195px;
      height: 3px;
      background-color: #ededed;
      content: "";
    }
  }
  .detail {
    margin-top: 55px;
    padding: 0 40px 40px;
    & /deep/ img {
      width: 100%;
    }
    /deep/ p{
      word-break: break-all;
    }
  }
  .service_box{
    position: fixed;
    right: 21px;
    bottom: 100px;
  }
}
</style>
